import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesNotifications } from "../../constants";

export const requestDeleteNotification = async (
  notificationId: string
): Promise<void> => {
  return await instance.delete(
    buildUrl(ApiRoutesNotifications.Notifications, notificationId)
  );
};
